module.exports = __webpack_public_path__ + "static/media/cswap-emblem-blue.f0ebccdc.svg";